import { Observable } from 'rxjs';
import { CountryModel } from '../domain/country.model';

export abstract class CountriesRepository {
  abstract getCountries(): Observable<CountryModel[]>;
  abstract getCountryVATByIsoCode3(isoCode3: string): Observable<number>;
}
